/*
 * Copyright (c) 2019  Apricot Courses, LLC. All Rights Reserved.
 */

import { Theme } from "@material-ui/core/styles/createMuiTheme";

import {
  title,
  section,
  mrAuto,
  mlAuto,
  container,
  description,
  cardTitle,
  coloredShadow,
} from "assets/jss/material-kit-pro-react.jsx";

const titleStyle = {
  ...title,
  marginBottom: "1rem",
  marginTop: 0,
  minHeight: "32px",
  textDecoration: "none",
};

export const sectionWhyStyle = ({ typography, palette }: any) => {
  // 'info' doesn't exist in Theme.palette, needs a solution for typing
  return {
    section: {
      padding: "2rem 0",
      textAlign: "center",
      "& h3": { fontSize: "1.2rem" },
    },
    title: {
      ...titleStyle,
    },
    description: {
      color: palette.info.main,
    },
    whyCard: {
      "@media (min-width:600px)": {
        padding: "0.25rem",
      },
      "@media (min-width:960px)": {
        padding: "1rem",
      },
      padding: "1rem 0",
      margin: "0 auto",
    },
  };
};

export const sectionHowStyle = ({ typography }: Theme) => {
  return {
    mrAuto,
    mlAuto,
    title,
    container,
    description: {
      ...description,
      marginBottom: "70px",
    },
    section: {
      ...section,
      padding: "20px 0px",
    },
    sectionTestimonials: {
      paddingTop: "50px",
      paddingBottom: "80px",
      textAlign: "center",
      "& $cardTitle": {
        marginTop: "0px",
      },
    },
    features5: {
      ...section,
      backgroundRepeat: "no-repeat",
      position: "relative",
      padding: "2.5rem 0px",
      textAlign: "center",
      "& $title": {
        zIndex: "2",
        position: "relative",
        marginBottom: "30px",
        color: "#fff",
      },
      "& p": {
        color: "#fff",
      },
      "&:after": {
        background: "rgba(10,10,00,0.45)",
        position: "absolute",
        width: "100%",
        height: "100%",
        content: "''",
        zIndex: "0",
        left: "0px",
        top: "0px",
      },
    },
    features: {
      textAlign: "center",
      paddingTop: "30px",
      pddingBottom: "0px",
    },
    featuresShow: {
      zIndex: 3,
      border: "1px solid rgba(255,255,255,0.35)",
      borderTop: 0,
      borderBottom: 0,
      "&:last-of-type": {
        borderRight: 0,
      },
      "&:first-of-type": {
        borderLeft: 0,
      },
      "& h4,& p,& svg,& .fab,& .fas,& .far,& .fal,& .material-icons": {
        color: "#fff",
      },
      "& p": {
        lineHeight: "24px",
        fontSize: "16px",
      },
    },
    ourClients: {
      textAlign: "center",
      "& img": {
        width: "100%",
        maxWidth: "140px",
        margin: "0 auto",
        display: "inline-block",
      },
    },
    cardTitle: {
      ...cardTitle,
      marginTop: 0,
    },
    cardDescription: {
      fontSize: "16px",
      lineHeight: "1.6em",
      color: "#999",
    },
    coloredShadow,
    alignLeft: {
      textAlign: "left",
    },

    infoArea: {
      padding: "1rem 0 0",
    },
  };
};
